<!--
  Guest layout — header only (no footer).
  Used by the /auth routes (verify, unauthorized) before a session exists,
  so there's no location to render in a footer yet.
-->
<div class="guest-layout">
  <app-queue-header />

  <main class="guest-layout-content">
    <router-outlet />
  </main>
</div>
